module.exports = __webpack_public_path__ + "img/1.f648e683.jpg";